class Regra {
  "id": Number = 0;
  "descricao": string = "";
  "criadoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
  "excluidoEm": Date = new Date();
}

export default Regra;
